uniform sampler2D uTex;
uniform float uLogDepthBufFC;
uniform vec3  uSkyTop;        // hemisphere-averaged HDR irradiance, upper half (linear)
uniform vec3  uSkyBottom;     // hemisphere-averaged HDR irradiance, lower half (linear)
uniform float uEffectBrightness; // per-scenario dim for the env-lit term (emissive untouched)

in vec2  vUv;
in float vAlpha;
in float vEmissive;
in vec3  vColor;
in float vFragDepth;

out vec4 fragColor;

// Bias toward sky-top — billboards have no real normal, but volumetric smoke
// catches more light from above than below.
const float SKY_UP_WEIGHT = 0.7;

void main() {
  // smoke_trail.jpg is an alpha-only band — use red channel as opacity
  float texA = texture(uTex, vUv).r;
  float a    = texA * vAlpha;
  if (a < 0.001) discard;

  vec3 color = vColor;

  // Environment lighting for non-emissive trails (matches particle_frag.glsl).
  float envBlend = 1.0 - clamp(vEmissive, 0.0, 1.0);
  if (envBlend > 0.0) {
    vec3 envLight = mix(uSkyBottom, uSkyTop, SKY_UP_WEIGHT);
    envLight = envLight / (vec3(1.0) + envLight);
    envLight *= 2.0 * uEffectBrightness;
    color *= mix(vec3(1.0), envLight, envBlend);
  }

  // Emissive boost — drives bloom pass pickup
  color *= (1.0 + vEmissive);

  // Premultiplied alpha
  fragColor = vec4(color * a, a);

  // Logarithmic depth
  gl_FragDepth = log2(vFragDepth) * uLogDepthBufFC * 0.5;
}
